import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Payroll, SharedData } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import { Link } from '@inertiajs/vue3';
    import { usePage, router } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import EditButton from '@/components/EditButton.vue';
    import ContinueButton from '@/components/ContinueButton.vue';

    interface Props {
        payroll: Payroll;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollTableActions',
  props: {
    payroll: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const props = __props;

    const { hasPermission } = usePermissions();

    const editPayroll = () => {
        router.visit(route('v2.salary.payrolls.show', { payrollId: props.payroll.id }));
    };

return (_ctx: any,_cache: any) => {
  return (_ctx.payroll.approved_by || !_unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_UPDATE))
    ? (_openBlock(), _createBlock(DataTableActions, {
        key: 0,
        data: _ctx.payroll
      }, {
        default: _withCtx(() => [
          (_unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_VIEW))
            ? (_openBlock(), _createBlock(ContinueButton, {
                key: 0,
                onClick: editPayroll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('forms.open')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"]))
    : (!_ctx.payroll.approved_by)
      ? (_openBlock(), _createBlock(DataTableActions, {
          key: 1,
          data: _ctx.payroll
        }, {
          default: _withCtx(() => [
            (_unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_UPDATE))
              ? (_openBlock(), _createBlock(EditButton, {
                  key: 0,
                  onClick: editPayroll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('forms.edit')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_DELETE))
              ? (_openBlock(), _createBlock(Delete, {
                  key: 1,
                  route: _ctx.route('v2.salary.payrolls.destroy'),
                  "query-key": [_unref(QueryKey).PAYROLLS, selectedCompanyId.value],
                  header: "salary.js.delete_title",
                  description: "salary.js.delete_content",
                  "success-message": "payrolls.deleted.success",
                  method: "post",
                  "request-data": { id: _ctx.payroll.id }
                }, null, 8, ["route", "query-key", "request-data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true)
}
}

})